import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { useBusinessCard } from 'components/BusinessCard/context'
import { Section, Row } from 'components/BusinessCard/components/StyledComponents'
import { H6, P, spacing } from '@PipelineDeals/shared-react-components'

const CollaboratorRow = styled(Row)`
  justify-content: flex-start;
  gap: ${spacing.sm};
`

const TypeIcon = styled.i`
  color: ${({ theme }) => theme.colors.gray[500]};
  font-size: 12px;
  width: 14px;
  flex-shrink: 0;
`

const CollaboratorName = styled(P)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const ProjectCollaborators = () => {
  const { t } = useTranslation()
  const {
    cardMeta: { showOnlyFields },
    resource: project
  } = useBusinessCard()

  if (!showOnlyFields.includes('project_collaborators')) return null
  if (!project.collaborators?.length) return null

  return (
    <Section>
      <H6>{t('businessCard.labels.collaborators')}</H6>
      {project.collaborators.map(collaborator => (
        <CollaboratorRow key={collaborator.id}>
          <TypeIcon
            className={collaborator.collaborator_type === 'User' ? 'fas fa-user' : 'fas fa-users'}
            title={collaborator.collaborator_type}
          />
          <CollaboratorName>{collaborator.collaborator_name}</CollaboratorName>
        </CollaboratorRow>
      ))}
    </Section>
  )
}

export default ProjectCollaborators
